import jwt_decode from 'jwt-decode'
type DecodedTokenType = {
  aud?: string
  exp: number
  iat?: number
  ids?: string
  iss?: string
  jti?: string
  nbf?: number
  sub?: string
  unique_name?: string
}
export const isTokenExpired = (token: string) => {
  try {
    const decodedToken: DecodedTokenType = jwt_decode(token)
    const currentTimeInSeconds = Date.now() / 1000
    return decodedToken.exp < currentTimeInSeconds
  } catch (error) {
    console.error('Error decoding token:', error)
    return true
  }
}
